export default {
  common: {
    search: 'Szukaj',
    selected: 'Wybrano',
  },
  actions: {
    clear: 'Wyczyść',
  },
};
